import { clone, path, pathOr } from 'ramda';
import {
	CLEAR_APP_ORGANIZATIONS,
	CLEAR_APP_ORGANIZATION_UPDATE_ERRORS,
	CLEAR_APP_ORGANIZATION_CREATE_ERRORS,
	GET_APP_ORGANIZATION,
	GET_APP_ORGANIZATIONS,
	FETCH_APP_ORGANIZATION_FAILED,
	FETCH_APP_ORGANIZATIONS_FAILED,
	FETCH_APP_ORGANIZATION_SUCCEEDED,
	FETCH_APP_ORGANIZATIONS_SUCCEEDED,
	UPDATE_APP_ORGANIZATION,
	UPDATE_APP_ORGANIZATION_FAILED,
	UPDATE_APP_ORGANIZATION_SUCCEEDED,
	CREATE_APP_ORGANIZATION,
	CREATE_APP_ORGANIZATION_FAILED,
	CREATE_APP_ORGANIZATION_SUCCEEDED,
} from './appOrganization.action';
import { appOrganizationsInitialState } from './appOrganization.initialState';

const createPendingState = (state, pendingType) => ({
	...state,
	[pendingType]: true,
});

const createErrorState = (state, pendingType, errorType, error) => ({
	...state,
	[pendingType]: false,
	[errorType]: error,
});

const clearErrorState = (state, errorType) => ({
	...state,
	[errorType]: null,
});

export const appOrganizationReducer = (state = appOrganizationsInitialState, action) => {
	switch (action.type) {
		case CLEAR_APP_ORGANIZATIONS: {
			return {
				...state,
				...appOrganizationsInitialState,
			};
		}

		case CLEAR_APP_ORGANIZATION_UPDATE_ERRORS: {
			return clearErrorState(state, 'updateError');
		}

		case CLEAR_APP_ORGANIZATION_CREATE_ERRORS: {
			return clearErrorState(state, 'createError');
		}

		case GET_APP_ORGANIZATION:
		case GET_APP_ORGANIZATIONS: {
			return createPendingState(state, 'pendingFetch');
		}

		case FETCH_APP_ORGANIZATION_FAILED:
		case FETCH_APP_ORGANIZATIONS_FAILED: {
			return createErrorState(state, 'pendingFetch', 'fetchError', action.payload);
		}

		case FETCH_APP_ORGANIZATION_SUCCEEDED: {
			const fetchedAppOrgId = path(['payload', '_id'], action);
			const newState = {
				...state,
				pendingFetch: false,
			};
			if (fetchedAppOrgId) {
				newState.entities = {
					...state.entities,
					[fetchedAppOrgId]: action.payload,
				};
			}

			return newState;
		}

		case FETCH_APP_ORGANIZATIONS_SUCCEEDED: {
			const previousStateEntities = clone(state.entities);
			const data = pathOr([], ['payload', 'data'], action);
			const entities = data.reduce((accumulator, datum) => {
				accumulator[datum._id] = datum;

				return accumulator;
			}, previousStateEntities);

			return {
				...state,
				entities,
				pendingFetch: false,
			};
		}

		case UPDATE_APP_ORGANIZATION: {
			return createPendingState(state, 'pendingUpdate');
		}

		case UPDATE_APP_ORGANIZATION_FAILED: {
			return createErrorState(state, 'pendingUpdate', 'updateError', action.payload);
		}

		case UPDATE_APP_ORGANIZATION_SUCCEEDED: {
			const updatedAppOrgId = path(['payload', '_id'], action);
			const newState = {
				...state,
				pendingUpdate: false,
			};

			if (updatedAppOrgId) {
				newState.entities = {
					...state.entities,
					[updatedAppOrgId]: action.payload,
				};
			}

			return newState;
		}

		case CREATE_APP_ORGANIZATION: {
			return createPendingState(state, 'pendingCreate');
		}

		case CREATE_APP_ORGANIZATION_FAILED: {
			return createErrorState(state, 'pendingCreate', 'createError', action.payload);
		}

		case CREATE_APP_ORGANIZATION_SUCCEEDED: {
			const createdAppOrgId = path(['payload', '_id'], action);
			const newState = {
				...state,
				pendingCreate: false,
			};

			if (createdAppOrgId) {
				newState.entities = {
					...state.entities,
					[createdAppOrgId]: action.payload,
				};
			}

			return newState;
		}

		default: {
			return state;
		}
	}
};



// WEBPACK FOOTER //
// ./src/redux/appOrganizations/appOrganization.reducer.js